import { VIEWS_CHART_COUNT } from "../../../../utils/constants";
import * as Types from "../../../actions/actionTypes";

const initialState = {
  allNuggetsFetched: false,
};
const start = VIEWS_CHART_COUNT.ads.nugget.start;
const end = VIEWS_CHART_COUNT.ads.nugget.end;

for (let i = start; i < end; i++) {
  initialState["adsNugget" + i] = {
    data: {
      chart_info: {
        chart_label: "",
        data: {},
      },
    },
    loading: true,
    error: "",
  };
}

function adsNuggetReducer(state = initialState, action) {
  const newState = { ...state };
  for (let i = start; i < end; i++) {
    let nuggetNumber = "adsNugget" + i;

    if (
      action.type === Types.adsNuggetActionTypes[`ADS_NUGGET_${i}_DATA_LOADING`]
    ) {
      newState[nuggetNumber] = {
        ...state[nuggetNumber],
        loading: action.payload,
      };
      return newState;
    }

    if (
      action.type === Types.adsNuggetActionTypes[`ADS_NUGGET_${i}_DATA_LOADED`]
    ) {
      newState[nuggetNumber] = {
        ...state[nuggetNumber],
        data: action.payload,
        error: "",
      };
      return newState;
    }
    if (
      action.type ===
      Types.adsNuggetActionTypes[`ADS_NUGGET_${i}_DATA_LOAD_ERROR`]
    ) {
      newState[nuggetNumber] = {
        ...state[nuggetNumber],
        error: action.payload,
      };
      return newState;
    }
  }
  if (action.type === Types.ADS_NUGGETS_FETCHED) {
    return {
      ...state,
      allNuggetsFetched: action.payload,
    };
  }

  if (action.type === Types.RESET_ADS_CHART_DATA) {
    return initialState;
  }
  return state;
}

export default adsNuggetReducer;
